"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    viewBox: "0 0 61 20.6",
    width: "61",
    height: "20.6",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M60.5,16.5h-5.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5H60V1H3.3v12.5l6.9,2h21.4c0.3,0,0.5,0.2,0.5,0.5           s-0.2,0.5-0.5,0.5H10.2c0,0-0.1,0-0.1,0l-7.3-2.1c-0.2-0.1-0.4-0.3-0.4-0.5V0.5C2.3,0.2,2.5,0,2.8,0h57.7C60.8,0,61,0.2,61,0.5V16           C61,16.3,60.8,16.5,60.5,16.5z",
    id: "path1"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M6,18.8c-0.3,0-0.5-0.2-0.5-0.5v-3c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3C6.5,18.6,6.2,18.8,6,18.8z",
    id: "path2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M43.4,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2C46.6,19.1,45.2,20.6,43.4,20.6z            M43.4,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S44.6,15.2,43.4,15.2z",
    id: "path3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M51,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2           C54.1,19.1,52.7,20.6,51,20.6z M51,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2S52.2,15.2,51,15.2z",
    id: "path4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M35.9,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2C39.1,19.1,37.7,20.6,35.9,20.6z            M35.9,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S37.1,15.2,35.9,15.2z",
    id: "path5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "-3.6",
    y: "6.1",
    transform: "matrix(6.513794e-11 1 -1 6.513794e-11 8.6544 5.7671)",
    fill: "#9ECE06",
    width: "10",
    height: "2.2",
    id: "rect5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M2.5,12.5H0.3c-0.2,0-0.3-0.2-0.3-0.3v-10C0,2,0.2,1.9,0.3,1.9h2.2c0.2,0,0.3,0.2,0.3,0.3v10           C2.9,12.4,2.7,12.5,2.5,12.5z M0.7,11.9h1.5V2.6H0.7V11.9z",
    id: "path6"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "43.1",
    cy: "8.4",
    r: "4.7",
    id: "circle6"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(0.62499958,0,0,0.62499958,8.0000006,1.7)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 4.46978,0.813004 C 4.57392,0.580258 4.50936,0.310178 4.31083,0.14393 4.11107,-0.022901 3.82362,-0.0468173 3.59707,0.0832642 0.219504,2.02399 -1.02714,7.01317 0.929609,10.7605 2.74994,14.247 3.84859,16.351 2.13301,20.1864 c -0.10414,0.2328 -0.03958,0.5028 0.15895,0.6691 0.19976,0.1668 0.48721,0.1907 0.71376,0.0607 3.37635,-1.9408 4.62299,-6.93 2.66685,-10.679 C 3.85285,6.75126 2.7542,4.6472 4.46978,0.813004 Z m 6.69912,0 C 11.273,0.580258 11.2085,0.310178 11.0099,0.14393 10.8102,-0.022901 10.5227,-0.0468173 10.2962,0.0832642 6.91921,2.02399 5.67257,7.01375 7.62871,10.761 c 1.82033,3.4866 2.91899,5.5906 1.2034,9.426 -0.10414,0.2327 -0.03959,0.5028 0.15895,0.6691 0.19976,0.1668 0.48721,0.1907 0.71376,0.0606 C 13.0812,18.976 14.3278,13.9868 12.3717,10.2378 10.552,6.75126 9.4533,4.6472 11.1689,0.813004 Z M 19.0708,10.2378 C 17.2511,6.75126 16.1524,4.6472 17.868,0.813004 17.9721,0.580258 17.9076,0.310178 17.709,0.14393 17.5093,-0.022901 17.2218,-0.0468173 16.9953,0.0832642 13.6183,2.02399 12.3717,7.01375 14.3278,10.761 c 1.8203,3.4866 2.919,5.5906 1.2034,9.426 -0.1041,0.2327 -0.0396,0.5028 0.159,0.6691 0.1997,0.1668 0.4872,0.1907 0.7137,0.0606 3.3764,-1.9407 4.623,-6.9305 2.6669,-10.6789 z",
    fill: "#da1e28",
    id: "path1-3"
  })));
};

exports["default"] = _default;